import {
  createElement,
  Fragment,
  useEffect,
  useRef,
  useState,
} from 'react';
import { render } from 'react-dom';

import {
  useSearchBox,
} from 'react-instantsearch-hooks';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { debounce } from '@algolia/autocomplete-shared';

import '@algolia/autocomplete-theme-classic/dist/theme.css';

const fireGAEvent = (event, eventProps = {}) => {
  // console.log('GA EVENT FIRED:', event, eventProps);
  window.dataLayer.push({
    event,
    eventProps,
  });
};

export function Autocomplete({
  searchClient,
  className,
  ...autocompleteProps
}) {
  const autocompleteContainer = useRef(null);

  const { query, refine: setQuery } = useSearchBox();

  const [
    instantSearchUiState,
    setInstantSearchUiState,
  ] = useState({ query });

  const debouncedSetInstantSearchUiState = debounce(
    setInstantSearchUiState,
    500
  );

  useEffect(() => {
    setQuery(instantSearchUiState.query);
  }, [instantSearchUiState]);

  useEffect(() => {
    if (!autocompleteContainer.current) {
      return;
    }

    const autocompleteInstance = autocomplete({
      ...autocompleteProps,
      container: autocompleteContainer.current,
      initialState: { query },
      // plugins,
      onReset() {
        setInstantSearchUiState({ query: '' });
      },
      onSubmit({ state }) {
        setInstantSearchUiState({ query: state.query });
        fireGAEvent('search_bar_terms_submitted', {
          data: {
            query: state.query,
          }
        });
        window.location.assign(`/marketplace/search?query=${state.query}`);
      },
      onStateChange({ prevState, state }) {
        if (prevState.query !== state.query) {
          console.log('search terms entered:' ,state.query);
          if (state.query.length > 0) {
            fireGAEvent('search_bar_terms_typed', {
              data: {
                query: state.query,
              }
            });
          }
          debouncedSetInstantSearchUiState({
            query: state.query,
          });
        }
      },
      // renderNoResults({ state, render }, root) {
        // if (state.query && state.nbHits === 0) {
        //   render(`No results for "${state.query}".`, root);
        //   // return <NoResults query={searchState.query} isSearching={searching} />
        // }
      // },
      navigator: {
        navigate({ itemUrl, query }) {
          console.log('query', query);
          // window.location.assign(itemUrl);
        },
        navigateNewTab({ itemUrl }) {
          const windowReference = window.open(itemUrl, '_blank', 'noopener');

          if (windowReference) {
            windowReference.focus();
          }
        },
        navigateNewWindow({ itemUrl }) {
          window.open(itemUrl, '_blank', 'noopener');
        },
      },
      renderer: { createElement, Fragment, render: render },
    });

    return () => autocompleteInstance.destroy();
  }, []);

  return <div 
    className={className} 
    ref={autocompleteContainer}
    onClick={() => {
      console.log('search clicked');
      fireGAEvent('search_bar_clicked');
    }}
  />;
}
